import { RootState } from "../../utils/types"

export const thirdPartyUserSelector = (state: RootState) =>
  state.thirdPartyUser
